/**
 * @generated SignedSource<<e2b6979fa112f7d65ac2c76b7cb4c523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
export type OrganizationContextInput = {
  clientMutationId?: string | null;
  cloudId?: string | null;
  orgId: string;
};
export type HomeWorkspaceSwitcherQuery$variables = {
  context?: OrganizationContextInput | null;
};
export type HomeWorkspaceSwitcherQuery$data = {
  readonly userOrganizationByContext: {
    readonly workspaces: ReadonlyArray<{
      readonly UUID: string;
      readonly cloudId: string;
      readonly name: string;
      readonly type: WorkspaceType;
    } | null> | null;
  };
};
export type HomeWorkspaceSwitcherQuery = {
  response: HomeWorkspaceSwitcherQuery$data;
  variables: HomeWorkspaceSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "organizationContext",
    "variableName": "context"
  }
],
v2 = {
  "alias": "UUID",
  "kind": "ScalarField",
  "name": "uuid"
},
v3 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HomeWorkspaceSwitcherQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "userOrganizationByContext",
          "plural": false,
          "selections": [
            {
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "workspaces",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/)
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "userOrganizationByContext"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeWorkspaceSwitcherQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "userOrganizationByContext",
        "plural": false,
        "selections": [
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1b6cc502d598db0d75380c1c2bc54df2",
    "id": null,
    "metadata": {},
    "name": "HomeWorkspaceSwitcherQuery",
    "operationKind": "query",
    "text": "query HomeWorkspaceSwitcherQuery(\n  $context: OrganizationContextInput\n) {\n  userOrganizationByContext(organizationContext: $context) {\n    workspaces {\n      UUID: uuid\n      cloudId\n      name\n      type\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "60d76b67b3d322f9924ebe0e3015fd0b";

export default node;
